module.exports = __webpack_public_path__ + "static/configBg-a1b545950edd3136b262d6bc390a689c.png";